import React, { useState, useEffect } from "react";
import icn from '../../assets/products/icn-category-1.png'
import FeaturedCards from "../FeaturedCards/FeaturedCards";
import Footer from "../Footer/Footer";
import Bitcou from "../../lib/Bitcou";
import { query } from "..";
import axios from "axios";
import { BrandItem } from "./BrandItem";
import { IPDATA_KEY } from "../../Env";
import { useHistory } from "react-router-dom";
import Select from "react-select";

const Catalog = ({ onAddToCart, fetchCart }) => {

  let searchTimeout;
  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);

  const [endReached, setEndReached] = useState(false);
  const [displayed, setDisplayed] = useState(8);
  const [countries, setCountries] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(undefined)
  const [selectedCategory, setSelectedCategory] = useState()
  const [categories, setCategories] = useState([])
  const [brands, setBrands] = useState([])

  useEffect(() => {
    const queryParamCountry = queryParams.get('country');
    const queryParamCategory = queryParams.get('category');
    if (queryParamCategory) setSelectedCategory(queryParamCategory)
    getCountries()
      .then((list) => {
        if (!queryParamCountry) {
          getUserCountry(list)
        } else {
          setSelectedCountry(list.find(c => c.id == queryParamCountry.toUpperCase()))
        }
      })
    getCategories()
  }, []);

  useEffect(() => {
    if (selectedCountry !== undefined)
      getBrands();
  }, [displayed, selectedCountry, selectedCategory])

  const getCountries = async () => {
    let q = await query(`{
      countries {
        id,
        name 
      }
    }`)
    const countries = q.countries.filter(c => c.name);
    countries.sort((a, b) => a.name < b.name ? -1 : 1);
    setCountries([{ id: null, name: 'All countries' }].concat(countries))
    return countries;
  }

  const getCategories = async () => {
    let q = await Bitcou.getCountries();
    setCategories(q.categories)
  }

  const getBrands = async () => {
    let q = await Bitcou.getBrands(displayed, selectedCountry.id, selectedCategory);
    setBrands(q.catalog);
    if (!selectedCountry || q.catalog.length % 8 > 0)
      setEndReached(true);
  }

  const onCountrySelect = (country) => {
    if(country.id){
      if (!queryParams.has('country'))
        queryParams.append('country', country.id)
      else queryParams.set('country', country.id);
    } else {
      queryParams.delete('country')
    }
    history.push({
      pathname: '/products',
      search: queryParams.toString()
    })
    setSelectedCountry(country);
  }

  const onCategorySelect = (categoryId) => {
    if(categoryId){
      if (!queryParams.has('category'))
        queryParams.append('category', categoryId)
      else queryParams.set('category', categoryId);
    } else {
      queryParams.delete('category')
    }
    history.push({
      pathname: '/products',
      search: queryParams.toString()
    })
    setSelectedCategory(categoryId);
  }

  const getUserCountry = (list) => {
    axios.get("https://api.ipdata.co?api-key=" + IPDATA_KEY)
      .then(({ data }) => {
        const userCountry = list.find(c => c.id == data.country_code.toUpperCase());
        setSelectedCountry(userCountry);
      })
      .catch(() => { });
  }

  const searchBrands = ({ target }) => {
    if (searchTimeout) clearTimeout(searchTimeout);

    searchTimeout = setTimeout(() => {
      Bitcou.searchBrands(target.value, selectedCountry.id)
        .then((data) => setBrands(data))
        .catch(() => alert('An error occured'));
    }, 1000)
  }

  return (
    <>
      <div className="products-search">
        <h3>Buy Gift cards online</h3>
        <div className="input-group search mt-4">
          <input type="text" className="form-control" placeholder="Search your products from here" onChange={searchBrands} />
          <div className="input-group-append">
            <button className="btn-yellow">Search</button>
          </div>
        </div>
      </div>

      <div className="list-products">
        <div className="categories col-lg-2">

          <div className="country">
            <h6>Country</h6>
            <Select className="select" classNamePrefix="country-select" formatOptionLabel={o => o.name}
              options={countries}
              onChange={onCountrySelect} value={selectedCountry} getOptionValue={o => o.name}>

            </Select>
          </div>
          <h6>Categories</h6>
          <hr />
          <ul>
            <li className={!selectedCategory ? "active" : "highlight"} onClick={onCategorySelect.bind(this, null)}>
              <a><span className="icon"> <img src={icn} alt="all" /> </span>All cards</a>
            </li>
            {categories && categories.map((category) => (
              <li className={selectedCategory == category.id ? "active" : "highlight"}>
                <a onClick={onCategorySelect.bind(this, category.id)}>
                  <span className="icon"> <img src={icn} alt={category.name} /> </span>{category.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="brands col-lg-10">

          <div className="list">
            <div className="buy-cards container ">
              <div className="section-body mb-3">
                <div className="cards-list">
                  <div className="row">
                    {brands && brands.map((brand) => (
                      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 flex-center-content mb-3" >
                        <BrandItem key={brand.id} brand={brand} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {brands && brands.length > 0 && !endReached && (
                <div className="text-center mb-5">
                  <button className="btn-yellow mt-5" data-toggle="modal" data-target="#exampleModal" onClick={setDisplayed.bind(this, displayed + 8)}>Load more</button>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
      <FeaturedCards country={selectedCountry && selectedCountry.id} handleAddCart={onAddToCart} />
    </>
  );
};

export default Catalog;
